import { MENU_CODE } from '~/constants/menu'

export const useContactUsPage = async () => {
  const nuxtApp = useNuxtApp()
  const {
    getPageInfo,
    getBreadcrumb,
    slugPageInfo,
  } = useNavigationMenu()

  const pageInfo = getPageInfo(MENU_CODE.CONTACT_US)
  const breadcrumbItem = ref<BreadCrumb[]>([])
  breadcrumbItem.value = getBreadcrumb()

  const websiteInfoStore = useWebsiteInfoStore()
  const websiteInfo = ref<WebsiteInfo>(websiteInfoStore.$state)

  const contactStore = useContactStore()
  const contact = ref<Contact>(contactStore.$state)

  const categoryEventName = ref('Contact')

  const dataAsync = ref<{
    products: Product[],
    addresses: Address[]
  }>({
    products: [],
    addresses: [],
  })

  const { data: fetchedData } = await useAsyncData('contact-us-data', async () => {
    const query = {
      page: 1,
      perPage: 9999,
      orderBy: 'position',
      sortBy: 'asc',
      'filters[recommended]': true,
    }
    const [productResult, addressResult] = await Promise.all([
      useProductApi(query),
      useAddressApi(),
    ])

    return {
      products: productResult.data.value && productResult.data.value.length > 0 ? productResult.data.value : [],
      addresses: addressResult.data.value && addressResult.data.value.length > 0 ? addressResult.data.value : [],
    }
  })

  if (fetchedData.value) {
    dataAsync.value = fetchedData.value
  }

  const statusStore = useStatusStore()
  onMounted(() => {
    statusStore.updatePreloading(false)
  })

  const isOnlyContactForm = computed(() => {
    return contact.value.formEnabled && dataAsync.value.addresses.length === 0
  })

  const isOnlyAddress = computed(() => {
    return !contact.value.formEnabled && dataAsync.value.addresses.length > 0
  })

  const isContactFormAndAddress = computed(() => {
    return contact.value.formEnabled && dataAsync.value.addresses.length > 0
  })

  useCustomSeo({
    title: () => slugPageInfo.value?.metaTitleFront,
    description: () => slugPageInfo.value?.metaDescriptionFront || slugPageInfo.value?.description,
    image: () => slugPageInfo.value?.ogImage?.large,
  })

  // Add schema.org data
  const { currentLocaleCode } = useLanguage()
  const { getPath, domain } = useNavigationMenu()

  nuxtApp.runWithContext(() => useSchemaOrg([
    defineWebPage({
      '@type': 'WebPage',
      '@id': `${domain.value}${getPath({ componentName: 'ContactUs' })}#webpage`,
      name: slugPageInfo?.value?.metaTitleFront,
      url: `${domain.value}${getPath({ componentName: 'ContactUs' })}`,
      description: contact.value.fullAddress || '',
      inLanguage: currentLocaleCode.value,
      about: {
        '@id': `${domain.value}/#organization`,
      },
      primaryImageOfPage: {
        '@id': `${domain.value}/#logo`,
      },
      isPartOf: {
        '@id': `${domain.value}/#website`,
      },
    }),
  ]))

  return {
    pageInfo,
    breadcrumbItem,
    websiteInfo,
    contact,
    categoryEventName,
    dataAsync,
    isOnlyContactForm,
    isOnlyAddress,
    isContactFormAndAddress,
  }
}